import React, { useEffect, useState } from "react";

import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  TextField,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import CloseIcon from "@mui/icons-material/Close";
import Api from "../../Api/Api";
import { getColorFromName } from "../../utils/ownerColors";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import pdfIcon from "../../assets/pdf_ic.png";
import imageIcon from "../../assets/img_ic.png";
import excelIcon from "../../assets/excel_ic.webp";
import wordIcon from "../../assets/word_ic.png";

export default function CommentDrawer({ open, onClose, connoteNo, row }) {
  const [comments, setComments] = useState([]);
  const [files, setFiles] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");

  const baseURL = Api;

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const username = user.username;
  const process = user.process;

  const currentUser = {
    username: localStorage.getItem("username"),
    process: localStorage.getItem("process"),
  };

  const deleteFile = async (id) => {
    try {
      await Api.post("/meta/deletedocument", {
        sno: id,
      });

      loadComments();
    } catch (err) {
      console.log(err);
    }
  };

  const getFileIcon = (filename = "") => {
    const ext = filename.split(".").pop()?.toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
      return (
        <img src={imageIcon} style={{ width: "100%", maxWidth: "40px" }} />
      );
    }

    if (["pdf"].includes(ext)) {
      return <img src={pdfIcon} style={{ width: "100%", maxWidth: "30px" }} />;
    }

    if (["xls", "xlsx", "csv"].includes(ext)) {
      return (
        <img src={excelIcon} style={{ width: "100%", maxWidth: "45px" }} />
      );
    }

    if (["doc", "docx"].includes(ext)) {
      return <img src={wordIcon} style={{ width: "100%", maxWidth: "30px" }} />;
    }

    return <InsertDriveFileIcon />;
  };

  const loadComments = async () => {
    if (!row?.id) return;

    try {
      const res = await Api.get(
        `/meta/getmeta?row_id=${row.id}&category=Claims`,
      );

      setComments(res.data.comments || []);
      setFiles(res.data.files || []);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (open && row?.id) {
      loadComments();
    }
  }, [open, row]);

  const saveComment = async () => {
    if (!commentText.trim()) return;

    try {
      await Api.post("/meta/savemeta", {
        row_id: row.id,
        category: "Claims",
        info_type: "Comments",
        meta_info: commentText,
        owner_id: user.username,
      });
      console.log(localStorage.getItem("username"));
      console.log(localStorage.getItem("user"));
      setCommentText("");

      loadComments();
    } catch (err) {
      console.log(err);
    }
  };

  const updateComment = async () => {
    try {
      await Api.post("/meta/updatecomment", {
        id: editingId,
        meta_info: editText,
        category: "Claims",
      });

      setEditingId(null);
      setEditText("");

      loadComments();
    } catch (err) {
      console.log(err);
    }
  };

  const uploadFile = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const formData = new FormData();
    formData.append("owner_id", user.username);
    formData.append("row_id", row.id);
    formData.append("file", file);
    formData.append("category", "Claims");
    formData.append("info_type", "File");
    console.log("Uploading as:", user.username);
    try {
      await Api.post("/meta/savemeta", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      loadComments();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ backgroundColor: "#4d3b3b0e" }}
    >
      <Box sx={{ width: 500, padding: "15px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            padding: "10px",
          }}
        >
          <Typography variant="h6">{connoteNo || "New Claim"}</Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tab} onChange={(e, value) => setTab(value)}>
            <Tab label="Message" />
            <Tab label="File" />
          </Tabs>
        </Box>

        {tab === 0 && (
          <>
            <TextField
              multiline
              rows={3}
              fullWidth
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Write comment..."
              sx={{ mt: 2 }}
            />

            <Button variant="contained" sx={{ mt: 2 }} onClick={saveComment}>
              Add Comment
            </Button>

            <Box mt={3}>
              {comments.map((c) => {
                const canEdit =
                  c.owner_id === username ||
                  process === 1 ||
                  process === 6 ||
                  process === "1" ||
                  process === "6";

                return (
                  <Box
                    key={c.id}
                    sx={{
                      p: 2,
                      border: "1px solid #ddd",
                      borderRadius: 1,
                      mb: 2,
                      mt: 2,
                      bgcolor: "#fff",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          backgroundColor: getColorFromName(c.owner_name),
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: "14px",
                          padding: "10px 8px",
                        }}
                      >
                        {c.owner_name
                          ?.split(" ")
                          .map((n) => n[0])
                          .join("")
                          .substring(0, 2)
                          .toUpperCase()}
                      </Box>

                      <Box>
                        <Typography fontWeight={600}>{c.owner_name}</Typography>

                        <Typography variant="caption" color="text.secondary">
                          {c.created_at}
                        </Typography>
                      </Box>
                      {canEdit && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditingId(c.id);
                            setEditText(c.meta_info);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                    {editingId === c.id ? (
                      <>
                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          value={editText}
                          onChange={(e) => setEditText(e.target.value)}
                          sx={{ mt: 1 }}
                        />

                        <Box sx={{ mt: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={updateComment}
                          >
                            Save
                          </Button>

                          <Button
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => {
                              setEditingId(null);
                              setEditText("");
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <Typography mt={1}>{c.meta_info}</Typography>
                    )}
                  </Box>
                );
              })}
            </Box>
          </>
        )}

        {tab === 1 && (
          <>
            <Button component="label" variant="contained" sx={{ mt: 2 }}>
              Upload File
              <input hidden type="file" onChange={uploadFile} />
            </Button>

            <Box sx={{ mt: 2 }}>
              {files.map((file) => {
                const canDelete =
                  file.owner_id === username ||
                  process === 1 ||
                  process === 6 ||
                  process === "1" ||
                  process === "6";

                return (
                  <Box
                    key={file.id}
                    sx={{
                      border: "1px solid #ddd",
                      p: 2,
                      borderRadius: 2,
                      mb: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      bgcolor: "#fff",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {getFileIcon(file.meta_info)}
                        <a
                          href={`http://127.0.0.1:8000/api/uploads/${file.meta_info}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {file.meta_info}
                        </a>{" "}
                        <br />
                      </Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        style={{ marginTop: "10px" }}
                      >
                        Uploaded by: {file.owner_name}
                      </Typography>
                    </Box>

                    {canDelete && (
                      <IconButton
                        color="error"
                        onClick={() => deleteFile(file.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                );
              })}
            </Box>
          </>
        )}

        {/* Add your comments UI here */}
      </Box>
    </Drawer>
  );
}
